export const chart_bullet_negative_measure_ColorScale_400 = {
  "name": "--pf-chart-bullet--negative-measure--ColorScale--400",
  "value": "#470000",
  "var": "var(--pf-chart-bullet--negative-measure--ColorScale--400, #470000)"
};
export default chart_bullet_negative_measure_ColorScale_400;